<template>
  <main
    class="console-page-child control-page-common "
    id="vehicle-history-violation"
  >
    <el-row class="console-title title-border">历史违章查询记录</el-row>
    <section class="search-model">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-autocomplete
              v-model="searchForm.nameMobile"
              :fetch-suggestions="querySearchAsync"
              clearable
              placeholder="请输入内容"
              :value-key="'val'"
              class="input-with-select"
              size="small"
              @select="handleSelect"
            >
              <el-select
                @change="changeValue"
                v-model="searchForm.driverInfo"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option
                  label="车牌号"
                  value="licensePlateNumber"
                ></el-option>
                <el-option label="司机姓名" value="driverName"></el-option>
              </el-select>
            </el-autocomplete>
          </el-col>
          <el-col :span="8">
            <el-form-item label="违章时间" class="self-range-date">
              <el-date-picker
                size="small"
                v-model="searchForm.time"
                type="daterange"
                align="center"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions2"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理状态" class="self-range-date">
              <el-radio-group v-model="searchForm.status" size="small">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button label="UNTREATED">未处理</el-radio-button>
                <el-radio-button label="PROCESSED">已处理</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="btn-wrapper">
        <el-button type="primary" @click="filterBefore" size="small"
          >筛 选</el-button
        >
        <el-button @click="reset" size="small">重 置</el-button>
      </el-row>
    </section>
    <el-export-btn
      keyUrl="/proxy/vehicle/driver/violation/export"
      statusUrl="/proxy/api/getFileUrl"
      :params="exportParams"
    />
    <span class="data-total">共有违章记录{{ totalItemCount }}条</span>
    <el-table :data="list" style="width: 100%" :max-height="maxHeight">
      <el-table-column
        prop="licensePlateNumber"
        fixed="left"
        :show-overflow-tooltip="true"
        label="车牌号"
        width="120"
      >
        <template slot-scope="scope">
          <span
            class="circle"
            :class="{ alert: scope.row.status === 'UNTREATED' ? true : false }"
          ></span>
          <span>{{ scope.row.licensePlateNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="110px"
        label="司机姓名"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.driverName ? scope.row.driverName : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        label="违章时间"
        width="180"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.happenTime ? scope.row.happenTime : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        :show-overflow-tooltip="true"
        label="违章地点"
      >
        <template slot-scope="scope">
          {{ scope.row.location ? scope.row.location : '--' }}
        </template>
      </el-table-column>
      <el-table-column width="180px" :show-overflow-tooltip="true" label="原因">
        <template slot-scope="scope">
          {{ scope.row.reason ? scope.row.reason : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="120px"
        label="罚款（元）"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.punishCount ? $utils.toYuan(scope.row.punishCount) : '--'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="扣分" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.deductMarks ? scope.row.deductMarks : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="120px"
        label="处理状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: scope.row.status === 'UNTREATED' ? '#FF5B60' : '',
            }"
          >
            {{ scope.row.status ? statusName[scope.row.status] : '--' }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        label="更新时间"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.updateTime ? scope.row.updateTime : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="合同编号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.contractCode ? scope.row.contractCode : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        width="100px"
        label="合同状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{
            scope.row.contractProcess
              ? contractStatusName[scope.row.contractProcess]
              : '--'
          }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template v-if="scope.row.status === 'UNTREATED'" slot-scope="scope">
          <span class="fresh-btn" @click="freshViolation(scope)">刷新</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list && list.length > 0"
      layout="jumper, next, pager, prev"
      :current-page="pageNo"
      :page-size="pageSize"
      :total="totalItemCount"
      @current-change="currentChange"
    >
    </el-pagination>
    <el-violation-determine-cost
      @get-violation-query="getViolationQuery"
      :violationParams="violationParams"
    >
    </el-violation-determine-cost>
  </main>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import exportBtn from '../../components/console-common/export-btn.vue'
import violationDetermineCost from '../../components/violation-manage/violation-determine-cost.vue'
export default {
  components: {
    'el-export-btn': exportBtn,
    'el-violation-determine-cost': violationDetermineCost,
  },
  created() {
    this.initDefaultParams()
    this.queryFilter()
  },
  data() {
    return {
      queryRefresh: false,
      violationParams: {},
      rowData: {},
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      exportParams: {},
      pageSize: 20,
      pageNo: 1,
      totalItemCount: 0,
      list: [],
      contractStatusName: {
        INACTIVE: '未开始',
        ACTIVE: '进行中',
        TERMINATED: '已结束',
      },
      statusName: {
        UNTREATED: '未处理',
        PROCESSED: '已处理',
      },
      searchForm: {
        status: '',
        driverInfo: 'licensePlateNumber',
        time: [],
      },
    }
  },
  computed: {
    ...mapState('vehicle', ['searchList']),
    maxHeight() {
      return window.innerHeight - 180
    },
    ...mapState('common', {
      commonLoading: 'commonLoading',
    }),
  },
  methods: {
    initDefaultParams() {
      const { params } = this.$route
      for (let item in params) {
        if (item === 'status') {
          this.searchForm.status = params[item]
        }
      }
    },
    queryFilter() {
      const query = this.$route.query
      if (query.licensePlateNumber) {
        this.searchForm.driverInfo = 'licensePlateNumber'
        this.searchForm.licensePlateNumber = query.licensePlateNumber
        this.searchForm.nameMobile = query.licensePlateNumber
      }
      if (query.startTime || query.endTime) {
        const now = moment(new Date()).format('YYYY-MM-DD')
        this.searchForm.time.push(query.startTime || '')
        this.searchForm.time.push(query.endTime || now)
      }
      this.filter()
    },
    currentChange(val) {
      this.pageNo = val
      this.filter()
    },
    filterBefore() {
      this.pageNo = 1
      this.filter()
    },
    filter() {
      let params = Object.assign({}, this.searchForm)
      if (params.time && params.time.length) {
        params.startDate =
          params.time[0] &&
          params.time[0] !== '-' &&
          `${params.time[0]} 00:00:00`
        params.endDate = params.time[1] && `${params.time[1]} 23:59:59`
      }
      const name = this.searchForm.driverInfo
      const value = this.searchForm.nameMobile
      params[name] = value
      this.exportParams = Object.assign({}, params, { type: 'RECORD' })
      this.$request({
        url: '/proxy/vehicle/driver/violation/records',
        method: 'post',
        data: {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
          ...params,
        },
      }).then((res) => {
        if (!res.errorCode) {
          this.list = res.data
          this.totalItemCount = res.totalItemCount
          this.pageNo = res.pageNo
          this.pageSize = res.pageSize
        }
      })
    },
    reset() {
      this.searchForm = Object.assign(
        {},
        { driverInfo: 'licensePlateNumber', status: '' }
      )
      this.pageNo = 1
      this.filter()
    },
    handleSelect(item) {
      this.$set(this.searchForm, 'nameMobile', item.val)
      this.$forceUpdate()
    },
    querySearchAsync(queryString, cb) {
      const type =
        this.searchForm.driverInfo === 'driverName'
          ? 'DRIVERNAME'
          : 'LICENSEPLATENUMBER'
      this.$store.dispatch('vehicle/GET_DRIVEROPERATOR_LIST', {
        searchType: type,
        key: queryString,
      })
      setTimeout(() => {
        cb(this.searchList)
      }, 1000)
    },
    changeValue(value) {
      this.searchForm = Object.assign({}, { nameMobile: '' })
      this.searchForm.driverInfo = value
    },
    freshViolation(scope) {
      const {
        engineNumber,
        licensePlateNumber,
        vehicleIdentificationNumber,
      } = scope.row
      this.violationParams = {
        engineNumber,
        licensePlateNumber,
        vehicleIdentificationNumber,
        source: 'SINGLE',
        vehicleStatusList: 'SIGNED',
      }
      this.$store.dispatch('common/GET_LOADING')
      this.$store.dispatch('violationManage/GET_PRECALCULATE', {
        data: { ...this.violationParams },
        loadingControl: 'hand',
        loading: this.commonLoading,
      })
      this.rowData = scope.row
    },
    getViolationQuery() {
      const {
        licensePlateNumber,
        engineNumber,
        vehicleIdentificationNumber,
      } = this.rowData
      this.$request({
        url: '/proxy/violation/batch/async/fetch',
        method: 'post',
        data: {
          licensePlateNumber,
          engineNumber,
          vehicleIdentificationNumber,
          source: 'SINGLE',
        },
      }).then((res) => {
        if (!res || res.errorCode) {
          return
        }
        if (!res.errorCode && res.data) {
          const orderCode = res.data.orderCode
          this.fetchProgressData(orderCode)
        }
      })
    },
    fetchProgress(orderCode) {
      return this.$request({
        url: '/proxy/violation/batch/async/fetch/progress',
        method: 'post',
        data: {
          orderCode,
        },
      })
    },
    fetchProgressData(orderCode) {
      // 轮循次数
      let pollingTimes = 0
      // 轮询接口
      let timer = null
      let pollingMain = () => {
        this.fetchProgress(orderCode).then((res) => {
          // 轮循次数叠加  70s内未返回接口报网络超时
          pollingTimes++
          if (!res || res.errorCode) {
            return
          }
          if (!res.data && pollingTimes < 140) {
            timer = setTimeout(() => {
              pollingMain()
            }, 500)
            return
          }
          if (!res.data && pollingTimes >= 140) {
            this.$message({
              message: '网络超时,请重试!',
              type: 'error',
              showClose: true,
            })
          }
          this.refreshData()
          clearTimeout(timer)
        })
      }
      timer = setTimeout(() => {
        pollingMain()
      }, 500)
    },
    refreshData() {
      const { licensePlateNumber, violationCode } = this.rowData
      this.$request({
        url: '/proxy/vehicle/driver/violation/record/refresh',
        method: 'post',
        data: {
          licensePlateNumber,
          violationCode,
        },
      }).then((res) => {
        if (!res || res.errorCode) {
          return
        }
        this.$message({
          message: '刷新成功',
          type: 'success',
          showClose: true,
        })
        this.filter()
      })
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/common-color.styl'
#vehicle-history-violation
  .el-pagination
    width 100%
  .data-total
    float left
    padding-top 16px
    line-height 1
    font-size 16px
    color gray02
  .el-form-item__content
    height 32px
    line-height 32px
  .el-form-item__label
    height 32px
    line-height 32px
  .el-pagination
    position inherit
  .search-model
    margin 24px 0 40px 0
    .btn-wrapper
      margin-left 120px
    .el-input__inner
      width 225px
    .input-with-select
      .el-input-group__prepend
        background white
      .el-input__inner
        width 200px
      .el-select
        .el-input__inner
          width 120px
  .el-radio-button__orig-radio:checked+.el-radio-button__inner
    background rgba(47,134,246,0.10)
    border 1px solid rgba(47,134,246,0.30)
    color primary-color
  .el-radio-button__orig-radio:checked+.el-radio-button__inner
    box-shadow none
  .el-input-group__append, .el-input-group__prepend
    background #fff
  .export-wrapper
    height 32px
    line-height 32px
    margin-bottom 16px
    color gray02
    .el-button
      float right
      width 80px
      height 32px
      line-height 32px
      padding 0 16px
      text-align right
      color gray02
      background url('../../assets/images/console-common/export-btn.svg') no-repeat 16px center
  .fresh-btn
    color primary-color
    cursor pointer
  .circle
    display inline-block
    margin-top -2px
    vertical-align middle
    width 4px
    height 4px
    border-radius 50%
    background self-green
  .alert
    background error-color
  .tabel-slot
    display flex
    justify-content space-between
    > div:first-child
      margin-top 16px
      height 16px
      line-height 16px
      color gray02
  .el-table th
    padding 16px 0
  .el-table td
    padding 20px 0
  .el-table th div
    color #414b5d
  .el-pagination
    margin 36px 0 4px 0
    padding 0 5px
    width 100%
</style>
